/**
 * Id страны берем из:
 * https://staff.mamba.ru/translate/geoobjects.phtml?countryId=1894
 */
export const isRussia = (countryId: number) => countryId === 3159
export const isBelarus = (countryId: number) => countryId === 248
export const isKazakhstan = (countryId: number) => countryId === 1894
